import { ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { OrionContactSyncSettings } from './OrionContactSyncSettings'

export const OrionSpecificSettings = (): ClickNavigationSection[] => {
  return [{ id: 'contactSync', label: 'Contact Sync', content: () => <OrionContactSyncSettings /> }]
}
